const legalInformation = {
  en: {
    translation: {
      legal_information: "Legal information",
      business_type: "Business type",
      only_owner: "Are you the only owner?",
      partnership: "Partnership",
      corporation: "Corporation",
      corporation_label:
        "Società (spa, sapa, srl, sas, snc, ss, cooperative, ecc.)",
      sole_proprietorship: "Sole trader",
      sole_proprietorship_label:
        "Ditta individuale (Ristorante Roma di Rossi Mario)",
      physical_person: "Physical person",
      physical_person_label: "Persona fisica (no P.IVA)",
      coordinated: "Coordinated",
      accept_edit: "Accept edit",
      error_accept_edit:
        "Please, confirm data is correct before proceding to save",
      compulsory_data:
        "Con * i dati obbligatori secondo quanto previsto dagli art. 2250 c.c., art. 35, D.P.R. 663/1972, art. 2630 c.c."
    }
  },
  it: {
    translation: {
      legal_information: "Informazioni legali",
      business_type: "Tipo di società",
      only_owner: "Unipersonale / a socio unico",
      partnership: "Società a nome collettivo",
      corporation: "Società",
      people_coorporation: "Società di persone",
      capital_coorporation: "Società di capitali",
      people_corporation_label:
        "Società di persone (sas, snc, ss, cooperative, ecc.)",
      capital_corporation_label:
        "Società di capitali (spa, sapa, srl, srls, ecc.)",
      sole_proprietorship: "Ditta individuale",
      sole_proprietorship_label:
        "Ditta individuale (es. Ristorante Roma di Rossi Mario)",
      physical_person: "Persona fisica",
      physical_person_label: "Persona fisica (no P.IVA)",
      coordinated:
        "Soggetta a direzione e coordinamento di altra società o ente",
      accept_edit: "Accetto modifiche",
      error_accept_edit:
        "Per favore, conferma che i dati siano corretti prima di procedere al salvataggio",
      compulsory_data:
        "Con * i dati obbligatori secondo quanto previsto dagli art. 2250 c.c., art. 35, D.P.R. 663/1972, art. 2630 c.c."
    }
  }
};

export default legalInformation;
